const SITE_URL = 'https://lasoxp.com';

export const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'LasoXP',
  url: SITE_URL,
  logo: `${SITE_URL}/favicon/android-chrome-512x512.png`,
  description:
    'AI-powered guest experience platform for hotels. Turns your website into a 24/7 concierge that learns your property and answers guest questions.',
};

export const softwareApplicationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'LasoXP',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  url: SITE_URL,
  description:
    'AI concierge widget for hotels — answers guest questions on your website, builds guest profiles from every conversation, and drives direct bookings.',
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    availability: 'https://schema.org/InStock',
    description: 'Free personalized demo on your hotel website',
  },
};
